import uuid from "uuid";
const namespaced = true;

const state = {
    types: [
        {
            id: 0,
            slug: "provnr",
            title: "Provnummer",
            group_id: 0
        },
        {
            id: 1,
            slug: "ph",
            title: "pH",
            group_id: 1,
            width: 30
        },
        {
            id: 2,
            slug: "p_al",
            title: "Fosfor AL",
            legendTitle: "P-AL",
            group_id: 1,
            width: 30
        },
        {
            id: 3,
            slug: "k_al",
            title: "Kalium AL",
            legendTitle: "K-AL",
            group_id: 1,
            width: 30
        },
        {
            id: 4,
            slug: "mg_al",
            title: "Magnesium AL",
            legendTitle: "Mg-AL",
            group_id: 1,
            width: 35
        },
        {
            id: 5,
            slug: "k_mg_kvot",
            title: "Kalium/Magnesium-kvot",
            legendTitle: "K/Mg-kvot",
            group_id: 1,
            width: 47
        },
        {
            id: 6,
            slug: "ca_al",
            title: "Kalcium AL",
            legendTitle: "Ca-AL",
            group_id: 1,
            width: 35
        },
        {
            id: 7,
            slug: "p_hcl",
            title: "Fosfor HCl",
            legendTitle: "P-HCl",
            group_id: 2,
            width: 35
        },
        {
            id: 8,
            slug: "k_hcl",
            title: "Kalium HCl",
            legendTitle: "K-HCl",
            group_id: 2,
            width: 35
        },
        {
            id: 9,
            slug: "cu_hcl",
            title: "Koppar HCl",
            legendTitle: "Cu-HCl",
            group_id: 2,
            width: 38
        },
        {
            id: 10,
            slug: "bor",
            title: "Bor",
            group_id: 2,
            width: 25
        },
        {
            id: 11,
            slug: "lerhalt",
            title: "Lerhalt",
            group_id: 3,
            width: 35
        },
        {
            id: 12,
            slug: "mullhalt",
            title: "Mullhalt",
            group_id: 3,
            width: 40
        },
        {
            id: 13,
            slug: "sand_grovmo",
            title: "Sand-grovmo",
            group_id: 3,
            width: 55
        },
        {
            id: 14,
            slug: "jordart",
            title: "Jordart",
            group_id: 3,
            width: 55
        },
        {
            id: 15,
            slug: "cd_hno3",
            title: "Kadmium",
            legendTitle: "Cd_HNO3",
            group_id: 4,
            width: 45
        },
        {
            id: 16,
            slug: "zn",
            title: "Zink",
            legendTitle: "Zn",
            group_id: 5,
            width: 25
        },
        {
            id: 17,
            slug: "cu",
            title: "Koppar",
            legendTitle: "Cu",
            group_id: 5,
            width: 25
        },
        {
            id: 18,
            slug: "cr",
            title: "Krom",
            legendTitle: "Cr",
            group_id: 5,
            width: 25
        },
        {
            id: 19,
            slug: "ni",
            title: "Nickel",
            legendTitle: "Ni",
            group_id: 5,
            width: 25
        },
        {
            id: 20,
            slug: "pb",
            title: "Bly",
            legendTitle: "Pb",
            group_id: 5,
            width: 25
        },
        {
            id: 21,
            slug: "hg",
            title: "Kvicksilver",
            legendTitle: "Hg",
            group_id: 5,
            width: 25
        },
        {
            id: 22,
            slug: "volymvikt",
            title: "Volymvikt",
            legendTitle: "Volymvikt",
            group_id: 0,
            width: 47
        },
        {
            id: 23,
            slug: "t_varde",
            title: "T värde",
            legendTitle: "T värde",
            group_id: 0,
            width: 38
        },
        {
            id: 24,
            slug: "s_varde",
            title: "S värde",
            legendTitle: "S värde",
            group_id: 0,
            width: 38
        },
        {
            id: 25,
            slug: "basmattnadsgrad",
            title: "Basmättnadsgrad",
            legendTitle: "Basmättnadsgrad",
            group_id: 0,
            width: 70
        },
        {
            id: 26,
            slug: "kalkbehov",
            title: "Kalkbehov",
            legendTitle: "Kalkbehov",
            group_id: 0,
            width: 55
        },
        {
            id: 27,
            slug: "fe_al",
            title: "Fe-AL",
            legendTitle: "Fe-AL",
            group_id: 0,
            width: 32
        },
        {
            id: 28,
            slug: "al_al",
            title: "Al-AL",
            legendTitle: "Al-AL",
            group_id: 0,
            width: 32
        },
        {
            id: 29,
            slug: "mineralkvave_kg_n_ha",
            title: "Mineralkväve Kg N ha",
            legendTitle: "Mine. Kg N ha",
            group_id: 6,
            width: 60
        },
        {
            id: 30,
            slug: "mineralkvave_no3_n",
            title: "Mineralkväve NO3-N",
            legendTitle: "Mine. NO3-N",
            group_id: 6,
            width: 57
        },
        {
            id: 31,
            slug: "mineralkvave_nh4_n",
            title: "Mineralkväve NH4-N",
            legendTitle: "Mine. NH4-N",
            group_id: 6,
            width: 57
        },
        {
            id: 32,
            slug: "mineralkvave_djup",
            title: "Mineralkväve djup",
            legendTitle: "Mine. Djup",
            group_id: 6,
            width: 50
        },
        {
            id: 33,
            slug: "cystnematoder_potatis",
            title: "Cystnematoder potatis",
            legendTitle: "Cyst. Potatis",
            group_id: 7,
            width: 65
        },
        {
            id: 34,
            slug: "cystnematoder_betor",
            title: "Cystnematoder betor",
            legendTitle: "Cyst. Betor",
            group_id: 7,
            width: 60
        },
        {
            id: 35,
            slug: "cystnematoder_spannmal",
            title: "Cystnematoder spannmål",
            legendTitle: "Cyst. Spannmål",
            group_id: 7,
            width: 65
        },
        {
            id: 36,
            slug: "fin_lerhalt",
            title: "Fin lerhalt",
            legendTitle: "Fin lerhalt",
            group_id: 3,
            width: 48
        },
        {
            id: 37,
            slug: "ovrigt",
            title: "Övrigt",
            legendTitle: "Övrigt",
            group_id: 0,
            width: 80
        },
        {
            id: 38,
            slug: "p_olsen",
            title: "Fosfor (P-Olsen)",
            legendTitle: "Fosfor (P-Olsen)",
            group_id: 0,
            width: 80
        }
    ],

    groups: [
        {
            id: 1,
            title: "Grundanalys"
        },
        {
            id: 2,
            title: "Förrådsanalys"
        },
        {
            id: 3,
            title: "Jordart"
        },
        {
            id: 4,
            title: "Kadmium"
        },
        {
            id: 5,
            title: "Tungmetall"
        },
        {
            id: 6,
            title: "Mineralkväve"
        },
        {
            id: 7,
            title: "Cystnematoder"
        },
        {
            id: 0,
            title: "Övriga"
        }
    ],

    hasExtraAnalyses: false
};

const getters = {
    groups: state => {
        return state.groups;
    },
    hasExtraAnalyses: state => {
        return state.hasExtraAnalyses;
    },
    groupsWithTypes: (state, getters) =>
        getGroupsWithTypes(state.groups, getters.types),

    allTypes: (state, getters) => {
        return getters.translatedTypes;
    },
    types: (state, getters) => getFilteredTypes(getters.translatedTypes),
    translatedTypes: (state, getters, rootState, rootGetters) =>
        getTranslatedTypes(
            rootGetters["layout/useInterpolationTitle"],
            rootGetters["interpolationSettings/settings"],
            state.types
        )
};

const actions = {
    APPEND_ADDITIONAL_ANALYSIS_TYPES({ commit }, types) {
        commit("addExtraTypesGroup");
        commit("addAnlalysisTypes", types);
    }
};

// mutations
const mutations = {
    addAnlalysisTypes(state, types) {
        let currId = Math.max(...state.types.map(o => o.id)) + 1;
        let group = state.groups.find(
            group => group.title === "Extra interpolationer"
        );

        types.forEach(type => {
            state.types.push({
                id: currId++,
                slug: type.slug,
                title: type.title,
                group_id: group.id,
                legendTitle: type.legendTitle
            });
        });

        state.hasExtraAnalyses = true;
    },

    addExtraTypesGroup(state) {
        let currId = Math.max(...state.groups.map(o => o.id)) + 1;
        state.groups.push({
            id: currId,
            title: "Extra interpolationer"
        });
    }
};

function getTranslatedTypes(useInterpolationTitle, settings, types) {
    if (useInterpolationTitle) {
        return types.map(type => {
            let setting = settings.find(setting => setting.type == type.slug);
            let tmp = Object.assign({}, type);
            if (setting) {
                tmp.title = setting.title;
                tmp.legendTitle = setting.description;
            }
            return tmp;
        });
    }
    return types;
}

function getGroupsWithTypes(groups, types) {
    return groups.map(group => {
        return {
            title: group.title,
            types: types.filter(type => type.group_id == group.id)
        };
    });
}

function getFilteredTypes(types) {
    return types.filter(type => {
        return type.slug !== "ovrigt";
    });
}

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
